<template>
  <div>
    <v-dialog scrollable width="400px" v-model="model" persistent>
      <material-card
        :title="$t('components.guides.import_benefits_dialog.import_benefits')"
        :color="$vuetify.theme.themes.light.success"
        icon="add"
      >
        <v-card-text>
          <v-form v-model="valid">
            <v-container>
              <v-row justify-center>
                <v-col cols="12">
                  <v-file-input
                    show-size
                    accept=".xlsx"
                    :label="
                      $t('components.vuematerialdashboard.core.appbar.benefits')
                    "
                    ref="file"
                    v-on:change="handleFileChange"
                    :rules="[$rules.required]"
                    class="required"
                    v-model="file"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-form>
          <v-alert
            v-for="(error, i) in errors"
            dense
            type="error"
            :key="i"
            dismissible
          >
            {{ $t(error) }}
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            @click="
              $emit('close');
              item = null;
            "
            :loading="saving"
          >
            {{ $t("globals.close") }}
          </v-btn>
          <v-btn
            color="primary"
            @click="save"
            :disabled="!valid || errors.length > 0"
            :loading="saving"
          >
            {{ $t("globals.import") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import ErrorHandler from "../../components/ErrorHandler.vue";
import { mapActions } from "vuex";
export default {
  props: ["model"],
  components: {
    ErrorHandler,
  },
  data() {
    return {
      error: null,
      successDialog: false,
      valid: false,
      saving: false,
      file: null,
      errors: [],
    };
  },
  watch: {
    model: {
      handler(v) {
        if (v) {
          this.file = null;
          this.errors = [];
        }
      },
    },
  },
  methods: {
    ...mapActions("claims", ["importBenefits"]),
    handleFileChange(file) {
      if (!file) {
        this.file = null;
        this.errors = [];
        return;
      }
      if (file.length == 0) {
        this.errors = [];
        return;
      }
      this.file = file;
    },
    async save() {
      try {
        this.saving = true;
        await this.importBenefits({
          file: this.file,
        });
        this.$emit("success", this.$t("globals.success"));
      } catch (error) {
        // this.error = error;
        this.errors = [];
        if (
          error.response &&
          error.response.status === 409 &&
          error.response.data.Code === 2600
        ) {
          const errors = JSON.parse(error.response.data.Message);
          console.log(errors);
          if (errors["2600"] !== null && errors["2600"] !== undefined) {
            for (const row of errors["2600"].rows) {
              this.errors.push(
                this.$t("components.errorhandler.error409_2600_{0}", [
                  row.toString(),
                ])
              );
            }
          }
          if (errors["2601"] !== null && errors["2601"] !== undefined) {
            for (const row of errors["2601"]) {
              this.errors.push(
                this.$t("components.errorhandler.error409_2601_{0}_{1}", [
                  row.wrong_name,
                  row.correct_name,
                ])
              );
            }
          }
          if (errors["2602"] !== null && errors["2602"] !== undefined) {
            for (const row of errors["2602"].rows) {
              this.errors.push(
                this.$t("components.errorhandler.error409_2602_{0}", [
                  row.toString(),
                ])
              );
            }
          }
          if (errors["2603"] !== null && errors["2603"] !== undefined) {
            for (const row of errors["2603"]) {
              this.errors.push(
                this.$t("components.errorhandler.error409_2603_{0}_{1}", [
                  row.row,
                  row.column,
                ])
              );
            }
          }
          if (errors["2604"] !== null && errors["2604"] !== undefined) {
            for (const row of errors["2604"].rows) {
              this.errors.push(
                this.$t("components.errorhandler.error409_2604_{0}", [
                  row.toString(),
                ])
              );
            }
          }
          if (errors["2605"] !== null && errors["2605"] !== undefined) {
            for (const row of errors["2605"]) {
              this.errors.push(
                this.$t("components.errorhandler.error409_2605_{0}_{1}", [
                  row.row,
                  row.column,
                ])
              );
            }
          }
          if (errors["2606"] !== null && errors["2606"] !== undefined) {
            for (const row of errors["2606"]) {
              this.errors.push(
                this.$t("components.errorhandler.error409_2606_{0}_{1}_{2}", [
                  row.row,
                  row.column,
                  row.type
                ])
              );
            }
          }
        } else {
          this.error = error;
        }
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style></style>
